import type { ReactNode } from "react";

import { cn } from "../../lib/utils";

export interface SectionProps {
  title: string;
  description?: string;
  children: ReactNode;
  className?: string;
}

export function Section({ title, description, children, className }: SectionProps): JSX.Element {
  return (
    <section className={cn("ui-section rounded-xl border border-slate-200/80 bg-white p-4", className)}>
      <div className="ui-section__header space-y-1">
        <div className="text-xs font-semibold uppercase tracking-wide text-slate-500">{title}</div>
        {description ? <div className="text-sm text-slate-600">{description}</div> : null}
      </div>
      <div className="ui-section__body text-sm text-slate-900">{children}</div>
    </section>
  );
}
